import type { AgeRange } from "@/App/types/twiageTypes";
import type { AgePeriodTitle } from "@/App/types/agePeriodTitle";

export enum AgePeriod {
  WEEKS = 1,
  MONTHS = 2,
  YEARS = 3,
}

export const agePeriods: Record<AgePeriod, AgePeriodTitle> = {
  [AgePeriod.WEEKS]: { title: "Weeks", shortenedTitle: "WKS", value: AgePeriod.WEEKS },
  [AgePeriod.MONTHS]: { title: "Months", shortenedTitle: "MTHS", value: AgePeriod.MONTHS },
  [AgePeriod.YEARS]: { title: "Years", shortenedTitle: "YRS", value: AgePeriod.YEARS },
};

export const ageRanges: Record<number, AgeRange> = {
  [agePeriods[AgePeriod.WEEKS].value]: { min: 1, max: 24 },
  [agePeriods[AgePeriod.MONTHS].value]: { min: 1, max: 24 },
  [agePeriods[AgePeriod.YEARS].value]: { min: 1, max: 120 },
};

export const agePeriodDefaultValue: number = AgePeriod.YEARS;
export const formatAgeGender = ({
  age,
  agePeriod,
  gender = undefined,
  hidePhi = false,
}: {
  age?: number;
  agePeriod?: AgePeriod;
  gender?: string;
  hidePhi?: boolean;
}): string => {
  const result = [];
  if (age && agePeriod) {
    let visibleAgeNumber = "";
    if (hidePhi && agePeriod === AgePeriod.YEARS && age > 89) {
      visibleAgeNumber = ">89";
    } else {
      visibleAgeNumber = age.toString();
    }
    result.push(`${visibleAgeNumber} ${agePeriods[agePeriod].shortenedTitle ?? ""}`);
  }
  if (gender) {
    result.push(`[${gender.toUpperCase()}]`);
  }
  return result.join(" ");
};
